<template>
  <div class="default-layout">
    <NavBar></NavBar>
    <div class="container mt-5">
      <Tabs v-if="tabs.length > 0" class="mb-4" :tabs="tabs" />
      <router-view></router-view>
    </div>
    <Dialog @ok="logout"
            :visible="showError"
            :title="errorTitle"
            :message="errorMessage"
            :show-cancel="false">
    </Dialog>
    <footer class="text-center">
      <small>Backoffice Juniti {{ version }}</small>
    </footer>
  </div>
</template>

<script>
import NavBar from "@/components/partial/NavBar.vue";
import {version} from "../../../package.json";
import Tabs from "@/components/partial/Tabs.vue";
import {getBackofficeRole, logout} from "@/util/authenticator";
import {listen} from "@/util/eventHandler";
import Dialog from "@/components/partial/Dialog.vue";

export default {
  name: "DefaultLayout",
  components: {Dialog, Tabs, NavBar},
  data() {
    return {
      version,
      tabs: [],
      backOfficeRole: "",
      showError: false,
      errorTitle: "Zugang aktuell nicht möglich",
      errorMessage: "Dein Zugang ist aktuell nicht verfügbar. Wende dich an deinen Administrator."
    };
  },
  created() {
    this.backOfficeRole = getBackofficeRole();
    this.$store.dispatch("FETCH_ACCOUNTINFOS").then(() => {
      this.loadTabs();
    });
    listen("tab-changed", this.loadTabs);
    listen("forbidden", this.forbiddenAccess);
  },
  methods: {
    logout,
    forbiddenAccess() {
      this.showError = true;
    },
    loadTabs() {
      if(this.backOfficeRole === "super-admin") {
        this.tabs = [
          {
            name: "Organisationseinheiten",
            path: "/organisations"
          },
          {
            name: "Single-Communities",
            path: "/communities"
          },
          {
            name: "Verbotene Wörter",
            path: "/bad-words"
          }
        ];
      } else if(this.backOfficeRole === "admin") {
        this.$store.dispatch("FETCH_ORGANISATION", this.$store.state.accountInfos.affiliationId).then(() => {
          this.tabs = this.$store.state.organisations[0] ? [
            {
              name: "Standorte",
              path: "/locations"
            },
            {
              name: this.$store.state.organisations[0].name,
              path: "/organisations/" + this.$store.state.organisations[0].id
            }
          ] : [
            {
              name: "Standorte",
              path: "/locations"
            },
          ];
        });
      } else if(this.backOfficeRole === "manager") {
        this.$store.dispatch("FETCH_LOCATION", this.$store.state.accountInfos.affiliationId).then(() => {
          this.tabs = this.$store.state.locations[0] ? [
            {
              name: "Communities",
              path: "/communities"
            },
            {
              name: this.$store.state.locations[0].name,
              path: "/locations/" + this.$store.state.locations[0].id
            }
          ] : [
            {
              name: "Communities",
              path: "/communities"
            },
          ];
        });
      }
    }
  }
};
</script>

<style scoped>

</style>
